const DEVICE_ID_KEY = "agce.device_id.v1";

function uuidv4() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** Stable browser device id — same value for login, verify, and all authenticated APIs. */
export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (id && String(id).trim()) return String(id).trim();
    id = uuidv4();
    localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return uuidv4();
  }
}

/** Persist server-issued device_id when login/verify returns one. */
export function persistDeviceIdFromServer(deviceId) {
  const id = deviceId != null ? String(deviceId).trim() : "";
  if (!id) return getOrCreateDeviceId();
  try {
    localStorage.setItem(DEVICE_ID_KEY, id);
  } catch {
    // ignore
  }
  return id;
}

export function deviceAuthHeaders(extra = {}) {
  return {
    "Content-Type": "application/json",
    "X-Device-Id": getOrCreateDeviceId(),
    ...extra,
  };
}
